import $ from 'jquery';
import Backbone from 'backbone';
import i18n, { t }  from '../i18n/i18n.js';
import View from '../../controls/View.js';
import MessagePopupView from '../../controls/MessagePopupView.js';
import app from '../App.js';

var template =
    '<table class="edit-table"><tbody>' +
    '<tr><td colspan="2">' +
    '<div class="sub-title">' +
    '<h2>{call_settings.red_subtitle}</h2>' +
    '<div class=description">{call_settings.red_description}</div>' +
    '</div>' +
    '</td></tr>' +
    '<tr><th><label for="edit_red_time_call">{call_settings.red_time_call}</label></th><td><input type="text" class="with-extras" data-name="red_time_call" id="edit_red_time_call" /><select data-name="red_time_call_amount" id="edit_red_time_call_amount"></select></td></tr>' +
    '<tr><th><label for="edit_red_hold_call">{call_settings.red_hold_call}</label></th><td><input type="text" class="with-extras" data-name="red_hold_call" id="edit_red_hold_call" /><select data-name="red_hold_call_amount" id="edit_red_hold_call_amount"></select></td></tr>' +
    '<tr><th><label for="edit_red_without_call">{call_settings.red_without_call}</label></th><td><input type="text" class="with-extras" data-name="red_without_call" id="edit_red_without_call" /><select data-name="red_without_call_amount" id="edit_red_without_call_amount"></select></td></tr>' +
    '<tr><th><label for="edit_red_mute_call">{call_settings.red_mute_call}</label></th><td><input type="text" class="with-extras" data-name="red_mute_call" id="edit_red_mute_call" /><select data-name="red_mute_call_amount" id="edit_red_mute_call_amount"></select></td></tr>' +

    '<tr><td colspan="2">' +
    '<div class="sub-title">' +
    '<h2>{call_settings.reasons_subtitle}</h2>' +
    '<div class=description">{call_settings.reasons_description}</div>' +
    '</div>' +
    '</td></tr>' +
    '<tr><th><label for="edit_busy_continue_reason">{call_settings.busy_continue_reason}</label></th><td><select id="edit_busy_continue_reason"></select></td></tr>' +
    '<tr><th><label for="edit_busy_end_reason">{call_settings.busy_end_reason}</label></th><td><select id="edit_busy_end_reason"></select></td></tr>' +
    '<tr><th><label for="edit_noresponse_continue_reason">{call_settings.noresponse_continue_reason}</label></th><td><select id="edit_noresponse_continue_reason"></select></td></tr>' +
    '<tr><th><label for="edit_noresponse_end_reason">{call_settings.noresponse_end_reason}</label></th><td><select id="edit_noresponse_end_reason"></select></td></tr>' +
    '<tr><th><label for="edit_wrongnumber_end_reason">{call_settings.wrongnumber_end_reason}</label></th><td><select id="edit_wrongnumber_end_reason"></select></td></tr>' +
    '<tr><th><label for="edit_answered_continue_reason">{call_settings.answered_continue_reason}</label></th><td><select id="edit_answered_continue_reason"></select></td></tr>' +
    '<tr><th><label for="edit_answered_end_reason">{call_settings.answered_end_reason}</label></th><td><select id="edit_answered_end_reason"></select></td></tr>' +
    '</tbody></table>';

var CallSettingsPage = View.extend({

    events: {
        'change input,select,textarea': 'onFieldChange'
    },

    className: 'main-body main-area-section',

    initialize: function (options) {
        var that = this;

        that.options = options = options || {};

        var $scrollPane = that.$scrollPane = $('<div class="scrollable-pane-content">').appendTo($('<div class="scrollable-pane">').appendTo(that.$el));

        var $table = that.$table = $(i18n.processLocalizedString(template)).appendTo($scrollPane);

        $('<div class="corner-commit-actions">').append(
            $('<button class="action-save-button">').text(t('save')).click(that.saveClicked.bind(that))
        ).appendTo($scrollPane);

        that.loadData();
    },

    render: function () {

        var that = this;

        if (that._generalSettings && that._continueReasons && that._endReasons) {

            var $table = that.$table;

            var $busyContinueReason = $table.find('select#edit_busy_continue_reason').empty().append($('<option>'));
            var $busyEndReason = $table.find('select#edit_busy_end_reason').empty().append($('<option>'));
            var $noresponseContinueReason = $table.find('select#edit_noresponse_continue_reason').empty().append($('<option>'));
            var $noresponseEndReason = $table.find('select#edit_noresponse_end_reason').empty().append($('<option>'));
            var $wrongnumberEndReason = $table.find('select#edit_wrongnumber_end_reason').empty().append($('<option>'));
            var $answeredContinueReason = $table.find('select#edit_answered_continue_reason').empty().append($('<option>'));
            var $answeredEndReason = $table.find('select#edit_answered_end_reason').empty().append($('<option>'));

            that._continueReasons.forEach(function (item) {
                $('<option>').val(item['id']).text(item['name']).appendTo($busyContinueReason);
                $('<option>').val(item['id']).text(item['name']).appendTo($noresponseContinueReason);
                $('<option>').val(item['id']).text(item['name']).appendTo($answeredContinueReason);
            });
            that._endReasons.forEach(function (item) {
                $('<option>').val(item['id']).text(item['name']).appendTo($busyEndReason);
                $('<option>').val(item['id']).text(item['name']).appendTo($noresponseEndReason);
                $('<option>').val(item['id']).text(item['name']).appendTo($wrongnumberEndReason);
                $('<option>').val(item['id']).text(item['name']).appendTo($answeredEndReason);
            });

            $table.find('select[data-name=red_time_call_amount]').empty().append(
                $('<option>').text(t('time_units.seconds')).val('seconds'),
                $('<option>').text(t('time_units.minutes')).val('minutes'),
                $('<option>').text(t('time_units.hours')).val('hours')
            );

            $table.find('select[data-name=red_hold_call_amount]').empty().append(
                $('<option>').text(t('time_units.seconds')).val('seconds'),
                $('<option>').text(t('time_units.minutes')).val('minutes'),
                $('<option>').text(t('time_units.hours')).val('hours')
            );

            $table.find('select[data-name=red_without_call_amount]').empty().append(
                $('<option>').text(t('time_units.seconds')).val('seconds'),
                $('<option>').text(t('time_units.minutes')).val('minutes'),
                $('<option>').text(t('time_units.hours')).val('hours')
            );

            $table.find('select[data-name=red_mute_call_amount]').empty().append(
                $('<option>').text(t('time_units.seconds')).val('seconds'),
                $('<option>').text(t('time_units.minutes')).val('minutes'),
                $('<option>').text(t('time_units.hours')).val('hours')
            );

            var settings = that._generalSettings.reduce(function(previousValue, currentValue) {
                previousValue[currentValue['key']] = currentValue['value'];
                return previousValue;
            }, {});

            ['red_time_call', 'red_hold_call', 'red_without_call', 'red_mute_call'].forEach(function (key) {
                var rowValue = settings[key];
                if (rowValue) {

                    rowValue = parseInt(rowValue, 10);

                    var amount = (rowValue > 3600 && (rowValue % 3600) === 0) ? 'hours' :
                        ((rowValue > 60 && (rowValue % 60) === 0) ? 'minutes' : 'seconds');

                    var value = amount === 'hours' ? (rowValue / 3600) :
                        (amount === 'minutes' ? (rowValue / 60) : rowValue);

                    that.$table.find('input[data-name=' + key + ']').val(value);
                    that.$table.find('select[data-name=' + key + '_amount]').val(amount);

                }
            });

            $busyContinueReason.val(settings['busy_continue_reason']);
            $busyEndReason.val(settings['busy_end_reason']);
            $noresponseContinueReason.val(settings['noresponse_continue_reason']);
            $noresponseEndReason.val(settings['noresponse_end_reason']);
            $wrongnumberEndReason.val(settings['wrongnumber_end_reason']);
            $answeredContinueReason.val(settings['answered_continue_reason']);
            $answeredEndReason.val(settings['answered_end_reason']);

        }

        return this;
    },

    onFieldChange: function () {
        this._saveNeeded = true;
        return this;
    },

    saveClicked: function () {
        var that = this;

        var $table = that.$table;

        that.$table.find('input.invalid,textarea.invalid,select.invalid').removeClass('invalid');

        var invalid = false;

        var $red_time_call_amount = that.$table.find('select[data-name=red_time_call_amount]').val();
        var $red_hold_call_amount = that.$table.find('select[data-name=red_hold_call_amount]').val();
        var $red_without_call_amount = that.$table.find('select[data-name=red_without_call_amount]').val();
        var $red_mute_call_amount = that.$table.find('select[data-name=red_mute_call_amount]').val();

        var $red_time_call = that.$table.find('input[data-name=red_time_call]');
        var $red_time_call_val = parseInt($red_time_call.val(), 10);
        if (!$red_time_call_val) {
            invalid = true;
            $red_time_call.addClass('invalid');
        }
        $red_time_call_val = $red_time_call_val * ($red_time_call_amount == 'hours' ? 3600 : ($red_time_call_amount == 'minutes' ? 60 : 1));

        var $red_hold_call = that.$table.find('input[data-name=red_hold_call]');
        var $red_hold_call_val = parseInt($red_hold_call.val(), 10);
        if (!$red_hold_call_val) {
            invalid = true;
            $red_hold_call.addClass('invalid');
        }
        $red_hold_call_val = $red_hold_call_val * ($red_hold_call_amount == 'hours' ? 3600 : ($red_hold_call_amount == 'minutes' ? 60 : 1));

        var $red_without_call = that.$table.find('input[data-name=red_without_call]');
        var $red_without_call_val = parseInt($red_without_call.val(), 10);
        if (!$red_without_call_val) {
            invalid = true;
            $red_without_call.addClass('invalid');
        }
        $red_without_call_val = $red_without_call_val * ($red_without_call_amount == 'hours' ? 3600 : ($red_without_call_amount == 'minutes' ? 60 : 1));

        var $red_mute_call = that.$table.find('input[data-name=red_mute_call]');
        var $red_mute_call_val = parseInt($red_mute_call.val(), 10);
        if (!$red_mute_call_val) {
            invalid = true;
            $red_mute_call.addClass('invalid');
        }
        $red_mute_call_val = $red_mute_call_val * ($red_mute_call_amount == 'hours' ? 3600 : ($red_mute_call_amount == 'minutes' ? 60 : 1));

        if (invalid) {
            that.$table.find('input.invalid,textarea.invalid,select.invalid').first().focus();
            return;
        }

        var data = {
            'rows': [
                {
                    "key": "red_time_call",
                    "value": $red_time_call_val
                },
                {
                    "key": "red_hold_call",
                    "value": $red_hold_call_val
                },
                {
                    "key": "red_without_call",
                    "value": $red_without_call_val
                },
                {
                    "key": "red_mute_call",
                    "value": $red_mute_call_val
                },
                {
                    "key": "busy_continue_reason",
                    "value": $table.find('select#edit_busy_continue_reason').val()
                },
                {
                    "key": "busy_end_reason",
                    "value": $table.find('select#edit_busy_end_reason').val()
                },
                {
                    "key": "noresponse_continue_reason",
                    "value": $table.find('select#edit_noresponse_continue_reason').val()
                },
                {
                    "key": "noresponse_end_reason",
                    "value": $table.find('select#edit_noresponse_end_reason').val()
                },
                {
                    "key": "wrongnumber_end_reason",
                    "value": $table.find('select#edit_wrongnumber_end_reason').val()
                },
                {
                    "key": "answered_continue_reason",
                    "value": $table.find('select#edit_answered_continue_reason').val()
                },
                {
                    "key": "answered_end_reason",
                    "value": $table.find('select#edit_answered_end_reason').val()
                }
            ]
        };

        var apiUrl;
        apiUrl = app.apiUrl('general_settings');

        app.AlertUI.showLoader(t('activity_indicator.saving'));

        that.ajaxJsonPost(apiUrl, data)
            .always(function () {
                app.AlertUI.hideLoader();
            })
            .then(function (response) {
                that._saveNeeded = false;

                new MessagePopupView({addClass: 'done', message: t('call_settings.saved_prompt'), queue: true}).show();
                Backbone.history.navigate('/management/settings/calls', { trigger: false, replace: true });

            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;
    },

    loadData: function () {
        var that = this;

        app.AlertUI.showLoader(t('activity_indicator.loading'));
        that.ajaxGet(app.apiUrl('general_settings'))
            .always(function () {
                that._generalSettingsXhr = null;
                app.AlertUI.hideLoader();
            })
            .then(function (data) {
                that._generalSettings = data;
                that.render();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        app.AlertUI.showLoader(t('activity_indicator.loading'));
        that.ajaxGet(app.apiUrl('continue_reasons'))
            .always(function () {
                that._continueReasonsXhr = null;
                app.AlertUI.hideLoader();
            })
            .then(function (data) {
                that._continueReasons = data;
                that.render();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        app.AlertUI.showLoader(t('activity_indicator.loading'));
        that.ajaxGet(app.apiUrl('end_reasons'))
            .always(function () {
                that._endReasonsXhr = null;
                app.AlertUI.hideLoader();
            })
            .then(function (data) {
                that._endReasons = data;
                that.render();
            })
            .fail(function (xhr, error) {
                app.showXhrError(xhr, error);
            });

        return that;
    },

    hasUnsavedChanges: function() {
        return this._saveNeeded;
    },

});

export default CallSettingsPage;
